import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { Z_INDEX_MAP, Z_INDEX_CONTENT_LAYER } from '../../util/zIndexConstants';
import { ThemeContext } from '../../context';
import BaseComponent from '../BaseComponent';

type FixedWidthContainerProps = {
  addPaddingTop?: boolean;
};

const FixedWidthContainer: React.FC<FixedWidthContainerProps> = ({ addPaddingTop, children }) => {
  const {
    homepage: { content_container },
    background: { background_color },
  } = useContext(ThemeContext);

  const Container = styled.div<{ addPaddingTop?: boolean }>`
    padding-top: 65px;
    padding-right: 32px;
    padding-left: 32px;
    max-width: 1020px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: ${Z_INDEX_MAP[Z_INDEX_CONTENT_LAYER]};
  `;

  const PADDING_X = 80;
  const PADDING_X_MOBILE = 20;
  const StyledBaseComponent = styled(BaseComponent)`
    padding-right: ${PADDING_X}px;
    padding-left: ${PADDING_X}px;
    padding-top: 32px;
    text-align: center;

    ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
      padding-right: ${PADDING_X_MOBILE}px;
      padding-left: ${PADDING_X_MOBILE}px;
    }
  `;

  return (
    <Container addPaddingTop={addPaddingTop}>
      <StyledBaseComponent
        background={content_container?.background}
        assets={content_container?.assets}
        border={content_container?.border}
        containerBackgroundColor={background_color}
        componentKey="content_container"
      >
        {children}
      </StyledBaseComponent>
    </Container>
  );
};

export default FixedWidthContainer;
